export default __webpack_public_path__ + "static/media/ic-vertical-dots-black.92390643.svg";